/* @flow */

export default {
  xsmall: 26,
  small: 40,
  medium: 50,
  large: 70,
  xlarge: 116,
  xxlarge: 190,
};
